import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './EditBuilding.scss';
import { Button } from 'reactstrap';
import { 
  ParkingModel , 
  BuildingInformation, 
  RedemptionModelInformation, 
  ConfigCommon,
  Config, 
  BuildingContent, 
  Loading,
} from '../../components';
import { 
  fetchUpdateBuilding, 
  fetchGetBuildingByBuildingID,
  setBuildingInformation,
  setBuildingParkingFeeModelCar,
  setBuildingParkingFeeModelMotorcycle,
  setRedemptionModelInformation,
  setConfigCommon,
  setConfig,
  setBuildingContent,  
} from '../../actions';
import { history, Modal } from '../../helpers';
import commonConstant from '../../common/_commonConstant';

class EditBuilding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'section': 'building-information',
      'loading': false,      
      'showConfirmOnboardModal' : false,
    };
  }

  componentDidMount() {
    if (this.props.match.path === commonConstant.pathOnboardForm) {      
      this.props.dispatch(fetchGetBuildingByBuildingID(this.props.match.params.buildingID));
      this.setState({
        'loading' : true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { getBuildingByRefNo, updateBuilding } = this.props;

    if (getBuildingByRefNo.status === 200 && getBuildingByRefNo.type === commonConstant.GET_BUILDING_BY_ID_SUCCESS && prevProps.getBuildingByRefNo != getBuildingByRefNo) {
      this.handleMappingData();
    } else if (updateBuilding.status === 200 && updateBuilding.type === commonConstant.UPDATE_BUILDING_SUCCESS && prevProps.updateBuilding != updateBuilding) {
      history.push(commonConstant.pathSelectBuilding);
    } else if (updateBuilding.status === 400 && updateBuilding.type === commonConstant.UPDATE_BUILDING_FAILURE && prevProps.updateBuilding != updateBuilding) {
      this.setState({
        'loading' : false,
      });
    }
  }

  handleIsCanUpdate = () => {
    const { 
      buildingInformation, buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, 
      redemptionModelInformation, configCommon, config, buildingContent,      
    } = this.props;
      
    const propertiesToCheck = [
      buildingInformation, buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, 
      redemptionModelInformation, configCommon, config, buildingContent,     
    ];
  
    const canSave = propertiesToCheck.every(property => property.data && property.data.isCanSave);
    
    if (canSave) {
      return true;
    } else {
      return false;
    }
  }

  handleMappingData = () => {
    const { getBuildingByRefNo } = this.props;
    const buildingData = getBuildingByRefNo.data;
    const carParkingFeeModel = buildingData.buildingParkingFeeModel.filter((item) => item.buildingParkingFeeModelType === 'CAR')[0];
    const motorcycleParkingFeeModel = buildingData.buildingParkingFeeModel.filter((item) => item.buildingParkingFeeModelType === 'MOTORCYCLE')[0];
    const carRedemptionModel = buildingData.buildingRedemptionModels.filter((item) => item.buildingRedemptionModelType === 'CAR')[0];
    const motorcycleRedemptionModel = buildingData.buildingRedemptionModels.filter((item) => item.buildingRedemptionModelType === 'MOTORCYCLE')[0];
    const carRedemptionModelTemplate = JSON.parse(carRedemptionModel.buildingRedemptionModel);
    const motorcycleRedemptionModelTemplate = JSON.parse(motorcycleRedemptionModel.buildingRedemptionModel);
    const buildingCommonConfig = buildingData.buildingConfig.buildingConfig.config.common;
    const carBuildingConfig = buildingData.buildingConfig.buildingConfig.config.car;
    const motorcycleBuildingConfig = buildingData.buildingConfig.buildingConfig.config.motorcycle;
    const thBuildingContent = buildingData.buildingConfig.buildingConfig.content.th;
    const enBuildingContent = buildingData.buildingConfig.buildingConfig.content.en;
        
    this.props.dispatch(setBuildingInformation(
      {
        ...buildingData.building.buildingInfo,
        'buildingRefNo' : buildingData.building.buildingRefNo,
        'buildingName' : buildingData.building.buildingName,        
        'buildingPOSID' : buildingData.building.buildingInfo.buildingPosID,      
        'buildingMerchantID' : buildingData.building.buildingMerchantID,      
        'isCanSave': true,
      },
    ));
    
    
    this.props.dispatch(setBuildingParkingFeeModelCar(
      {
        'status' : carParkingFeeModel.buildingParkingFeeModel !== '' ? 'ENABLE' : 'DISABLE',
        'isCanSave' : true,
        'parkingFeeModel' : carParkingFeeModel.parkingFeeModelTemplate.parkingFeeModelTemplateType,
        'parkingFeeModelData' : carParkingFeeModel.buildingParkingFeeModel,          
      },        
    ));
    
    this.props.dispatch(setBuildingParkingFeeModelMotorcycle(
      {
        'status' : motorcycleParkingFeeModel.buildingParkingFeeModel !== '' ? 'ENABLE' : 'DISABLE',
        'isCanSave' : true,
        'parkingFeeModel' : motorcycleParkingFeeModel.parkingFeeModelTemplate.parkingFeeModelTemplateType,
        'parkingFeeModelData' : motorcycleParkingFeeModel.buildingParkingFeeModel,      
      },        
    ));
        
    this.props.dispatch(setRedemptionModelInformation(
      {
        'maximumRedemptionMinutesCar' : carRedemptionModelTemplate.maxRedemptionMinutes,
        'maximumRedemptionQuotaCar' : carRedemptionModelTemplate.maxRedemptionQuota,
        'maximumRedemptionMinutesMotorcycle' : motorcycleRedemptionModelTemplate.maxRedemptionMinutes,
        'maximumRedemptionQuotaMotorcycle' : motorcycleRedemptionModelTemplate.maxRedemptionQuota,
        'redemptionModelCar' : carRedemptionModel.RedemptionModelTemplate.redemptionModelTemplateType,
        'redemptionModelMotorcycle' : motorcycleRedemptionModel.RedemptionModelTemplate.redemptionModelTemplateType,
        'isCanSave' : true,
      },        
    ));
        
    this.props.dispatch(setConfigCommon(
      {
        ...buildingCommonConfig,
        'maximumParkingFeePerDayActive' : buildingCommonConfig.maximumParkingFeePerDayActive ? 'ENABLE' : 'DISABLE',
        'isCanSave' : true, 
      },
    ));
      
    this.props.dispatch(setConfig(
      {
        'buildingConfigCar' : {
          'buildingFreeParkingMinutes' : carBuildingConfig.parking.buildingFreeParking.freeParkingMinutes,
          'buildingFreeParkingCondition' : carBuildingConfig.parking.buildingFreeParking.freeParkingCondition,
          'overNightActive': carBuildingConfig.parking.overnight.active ? 'ENABLE' : 'DISABLE',
          'overnightTimeStart': carBuildingConfig.parking.overnight.timeStart,
          'overnightTimeEnd': carBuildingConfig.parking.overnight.timeEnd,
          'overnightFee' : carBuildingConfig.parking.overnight.fee,
          'overnightChargeType' : carBuildingConfig.parking.overnight.overnightChargeType,
        },
        'buildingConfigMotorcycle' : {
          'buildingFreeParkingMinutes' : motorcycleBuildingConfig.parking.buildingFreeParking.freeParkingMinutes,
          'buildingFreeParkingCondition' : motorcycleBuildingConfig.parking.buildingFreeParking.freeParkingCondition,
          'overNightActive': motorcycleBuildingConfig.parking.overnight.active ? 'ENABLE' : 'DISABLE',
          'overnightTimeStart': motorcycleBuildingConfig.parking.overnight.timeStart,
          'overnightTimeEnd': motorcycleBuildingConfig.parking.overnight.timeEnd,
          'overnightFee' : motorcycleBuildingConfig.parking.overnight.fee,
          'overnightChargeType' : motorcycleBuildingConfig.parking.overnight.overnightChargeType,
        },
        'isCanSave' : true,
      },        
    ));
    
    
    this.props.dispatch(setBuildingContent(
      {
        'buildingContentTH' : {
          'buildingLogoURL' : thBuildingContent.common.buildingLogoImage,
          'carPaymentNote' : thBuildingContent.car.paymentNote,
          'carParkingNote' : thBuildingContent.car.parkingNote,
          'carTenantMemberParkingNote' : thBuildingContent.car.tenantMemberParkingNote,
          'motorcyclePaymentNote' : thBuildingContent.motorcycle.paymentNote,
          'motorcycleParkingNote' : thBuildingContent.motorcycle.parkingNote,
          'motorcycleTenantMemberParkingNote' :thBuildingContent.motorcycle.tenantMemberParkingNote,
          'welcomeVoiceURL' : thBuildingContent.common.welcomeVoiceURL,
        }, 
        'buildingContentEN' : {            
          'buildingLogoURL' : enBuildingContent.common.buildingLogoImage,
          'carPaymentNote' : enBuildingContent.car.paymentNote,
          'carParkingNote' : enBuildingContent.car.parkingNote,
          'carTenantMemberParkingNote' : enBuildingContent.car.tenantMemberParkingNote,
          'motorcyclePaymentNote' : enBuildingContent.motorcycle.paymentNote,
          'motorcycleParkingNote' : enBuildingContent.motorcycle.parkingNote,
          'motorcycleTenantMemberParkingNote' :enBuildingContent.motorcycle.tenantMemberParkingNote,
          'welcomeVoiceURL' : enBuildingContent.common.welcomeVoiceURL,
        },
        'isCanSave' : true,
      },
    ));

    this.setState({
      'loading' : false,
    });
  }

  handleUpdateBuilding = () => {
    const { 
      buildingInformation, buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, 
      redemptionModelInformation, configCommon, config, buildingContent,
      getBuildingByRefNo,
    } = this.props;

    const carParkingFeeModelId = getBuildingByRefNo.data.buildingParkingFeeModel.filter((item) => item.buildingParkingFeeModelType === 'CAR')[0].buildingParkingFeeModelID;
    const motorcycleParkingFeeModelId = getBuildingByRefNo.data.buildingParkingFeeModel.filter((item) => item.buildingParkingFeeModelType === 'MOTORCYCLE')[0].buildingParkingFeeModelID;
    const carRedemptionModelId = getBuildingByRefNo.data.buildingRedemptionModels.filter((item) => item.buildingRedemptionModelType === 'CAR')[0].buildingRedemptionModelID;
    const motorcycleRedemptionModelId = getBuildingByRefNo.data.buildingRedemptionModels.filter((item) => item.buildingRedemptionModelType === 'MOTORCYCLE')[0].buildingRedemptionModelID;
    const buildingConfigId = getBuildingByRefNo.data.buildingConfig.buildingConfigID;

    this.setState({
      'loading' : true,
    });    
         
    this.props.dispatch(fetchUpdateBuilding({      
      'building' : {
        'buildingID' : this.props.match.params.buildingID,
        'buildingInfo' : JSON.stringify(
          {
            'buildingAddress' : buildingInformation.data.buildingAddress,
            'buildingCompanyName' : buildingInformation.data.buildingCompanyName,
            'buildingContactEmail' : buildingInformation.data.buildingContactEmail,
            'buildingContactName' : buildingInformation.data.buildingContactName,
            'buildingContactNumber' : buildingInformation.data.buildingContactNumber,
            'buildingEmergencyContactNumber' : buildingInformation.data.buildingEmergencyContactNumber,
            'buildingPosID' : buildingInformation.data.buildingPOSID,
            'buildingTaxID' : buildingInformation.data.buildingTaxID,
            'buildingVatRatePercentage' : buildingInformation.data.buildingVatRatePercentage,        
            'buildingDashboardURL' : buildingInformation.data.buildingDashboardURL,    
          },
        ),
        'buildingMerchantID' : buildingInformation.data.buildingMerchantID,
        'buildingName' : buildingInformation.data.buildingName,
        'buildingRefNo' : buildingInformation.data.buildingRefNo,    
      },
      'buildingParkingFeeModelCar' : {
        'buildingParkingFeeModel' : buildingParkingFeeModelCar.data.parkingFeeModelData,
        'buildingParkingFeeModelID' : carParkingFeeModelId,
        'parkingFeeModelTemplateType' : buildingParkingFeeModelCar.data.parkingFeeModel,
      },
      'buildingParkingFeeModelMotorcycle' :  {
        'buildingParkingFeeModel' : buildingParkingFeeModelMotorcycle.data.parkingFeeModelData,
        'buildingParkingFeeModelID' : motorcycleParkingFeeModelId,
        'parkingFeeModelTemplateType' : buildingParkingFeeModelMotorcycle.data.parkingFeeModel,
      },
      'buildingRedemptionModelCar' :  {
        'buildingRedemptionModelID' : carRedemptionModelId,
        'maximumRedemptionMinutes' : redemptionModelInformation.data.maximumRedemptionMinutesCar,
        'maximumRedemptionQuota' : redemptionModelInformation.data.maximumRedemptionQuotaCar,
        'redemptionModel' : redemptionModelInformation.data.redemptionModelCar,
      } ,
      'buildingRedemptionModelMotorcycle' :   {
        'buildingRedemptionModelID' : motorcycleRedemptionModelId,
        'maximumRedemptionMinutes' : redemptionModelInformation.data.maximumRedemptionMinutesMotorcycle,
        'maximumRedemptionQuota' : redemptionModelInformation.data.maximumRedemptionQuotaMotorcycle,
        'redemptionModel' : redemptionModelInformation.data.redemptionModelMotorcycle,
      } ,
      'buildingConfigCommon' :  {
        'buildingConfigID' : buildingConfigId,
        'maximumParkingFeePerDayActive' : configCommon.data.maximumParkingFeePerDayActive,
        'exitPeriodAfterPayment': configCommon.data.exitPeriodAfterPayment,
        'maximumParkingFeePerDay': configCommon.data.maximumParkingFeePerDay,
      },        
      'buildingConfigCar' : {        
        'buildingConfigID' : buildingConfigId,                
        ...config.data.buildingConfigCar,
      }, 
      'buildingConfigMotorcycle' : {
        'buildingConfigID' : buildingConfigId,       
        ...config.data.buildingConfigMotorcycle,
      },
      'buildingContentTH' : {
        'buildingConfigID' : buildingConfigId,
        ...buildingContent.data.buildingContentTH,
      }, 
      'buildingContentEN' : {
        'buildingConfigID' : buildingConfigId,
        ...buildingContent.data.buildingContentEN,
      },
    }));
  }

    handleSection = (sectionName) => {      
      this.setState({
        'section': sectionName,
      });
    }

    handleSectionName = () => {
      const { section } = this.state;

      switch (section) {
        case 'building-information':
          return 'Building';
        case 'parking-model-car':
          return 'Parking model car';
        case 'parking-model-motorcycle':
          return 'Parking model motorcycle';
        case 'redemption-model':
          return 'Redemption model';
        case 'config-common':
          return 'Config common';
        case 'config':
          return 'Config';
        case 'content':
          return 'Content';
        default:
          break;
      }
    }

    handleCreateBuildingContent = () => {
      // TODO : change it follow content component 
      const { section } = this.state;

      switch (section) {
        case 'building-information':
          return (
            <div>
              <BuildingInformation disabledBuildingRefNo={true}/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('parking-model-car')} className="btn-primary btn-next">ถัดไป</Button>
              </div>          
            </div>
          );
        case 'parking-model-car':
          return (
            <div>
              <ParkingModel model={commonConstant.vehicleTypeCar} />
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('parking-model-motorcycle')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'parking-model-motorcycle':
          return (
            <div>
              <ParkingModel model={commonConstant.vehicleTypeMotorcycle} />
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('redemption-model')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'redemption-model':
          return (
            <div>
              <RedemptionModelInformation/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('config-common')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'config-common':
          return (
            <div>
              <ConfigCommon/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('config')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'config':
          return (
            <div>
              <Config/>
              <div className="btn-next-container">
                <Button onClick={() => this.handleSection('content')} className="btn-primary btn-next">ถัดไป</Button>
              </div>
            </div>
          );
        case 'content':
          return (
            <div>
              <BuildingContent/>
              <div className="btn-next-container">
                <Button onClick={() => this.setState({ 'showOnboardModal': true })} className="btn-primary btn-next" disabled={!this.handleIsCanUpdate()}>อัปเดต</Button>
              </div>
            </div>
          );
        default:
          break;
      }
    }

    handleCancelUpdate = () => {
      history.push(commonConstant.pathSelectBuilding);
    }

    handleBuildingName = () => {
      const { buildingInformation } = this.props;  
      
      if (buildingInformation.data && buildingInformation.data.buildingName){ 
        return buildingInformation.data.buildingName;
      } else {
        return 'Building name';
      }
    }


    handleBuildingRefNo = () => {
      const { buildingInformation } = this.props;  
      
      if (buildingInformation.data && buildingInformation.data.buildingRefNo){ 
        return buildingInformation.data.buildingRefNo;
      } else {
        return 'Building name';
      }
    }
    render() {
      const { 
        buildingInformation, buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, 
        redemptionModelInformation, configCommon, config, buildingContent,
      } = this.props;
      const { loading, showOnboardModal } = this.state;
      
      if (loading) {
        return <Loading/>;
      }

      return (        
        <div className="EditBuilding layout-box-page-without-margin">
          <Modal
            show={showOnboardModal ? true : false}            
            headerTemplate="a"            
          >
            <div className="update-building-modal">
              <div className="update-building-modal-title">คุณพร้อมที่จะส่งข้อมูลเลยหรือไม่</div>
              <div className="update-building-modal-description">       
                <div className="button-container">
                  <Button onClick={() => this.setState({ 'showOnboardModal': false })} className="btn-sixtary cancel-button">ยกเลิก</Button>
                  <Button onClick={() => this.handleUpdateBuilding()} className="btn-primary send-data-button">อัปเดต</Button>
                </div>
              </div>
            </div>
          </Modal>
          <div className="create-building-navbar">
            <div className="navbar-header" >
              <div className="building-name">{this.handleBuildingName()}</div>
              <div className="building-ref-number">{this.handleBuildingRefNo()}</div>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('building-information')}>
              <span className={`icon ${buildingInformation.data && buildingInformation.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Building information</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('parking-model-car')}>
              <span className={`icon ${buildingParkingFeeModelCar.data && buildingParkingFeeModelCar.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Parking Model Car</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('parking-model-motorcycle')}>
              <span className={`icon ${buildingParkingFeeModelMotorcycle.data && buildingParkingFeeModelMotorcycle.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Parking Model Motorcycle</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('redemption-model')}>
              <span className={`icon ${redemptionModelInformation.data && redemptionModelInformation.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Redemption model information</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('config-common')}>
              <span className={`icon ${configCommon.data && configCommon.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Config common</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('config')}>
              <span className={`icon ${config.data && config.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Config (Car / Motorcycle)</span>
            </div>
            <div className="navbar-item" onClick={() => this.handleSection('content')}>
              <span className={`icon ${buildingContent.data && buildingContent.data.isCanSave ? 'icon-check' : 'icon-warning'}`} />
              <span className="navbar-item-text">Content</span>
            </div>
          </div>
          <div className="create-building-content-container">
            <div className="create-building-header">
              <div className="create-building-title">{this.handleSectionName()}</div>
              <div className="create-building-button-container">
                <div className="draft-button-container">
                  <Button onClick={() => this.handleCancelUpdate()} className="btn-sixtary draft-button" >ยกเลิก</Button>
                </div>
                <Button onClick={() => this.setState({ 'showOnboardModal': true })} className="btn-primary send-data-button" disabled={!this.handleIsCanUpdate()}>อัปเดต</Button>
              </div>
            </div>
            <div className="create-building-content">
              {
                this.handleCreateBuildingContent()
              }
            </div>
          </div>
        </div>
      );
    }
}

const mapStateToProps = ({ 
  buildingInformation,
  buildingParkingFeeModelCar, 
  buildingParkingFeeModelMotorcycle, 
  redemptionModelInformation,
  configCommon,
  config,
  buildingContent,
  buildingTenant,
  buildingIotDevice,
  buildingParkingDayConfig,
  getBuildingByRefNo,
  updateBuilding,  
}) => ({
  buildingInformation, 
  buildingParkingFeeModelCar, 
  buildingParkingFeeModelMotorcycle, 
  redemptionModelInformation, 
  configCommon,
  config,
  buildingContent,
  buildingTenant,
  buildingIotDevice,
  buildingParkingDayConfig,
  getBuildingByRefNo,
  updateBuilding,  
});

export default connect(mapStateToProps)(EditBuilding);

EditBuilding.propTypes = {
  'dispatch' : PropTypes.func,
  'match' : PropTypes.shape({
    'path' : PropTypes.string,
    'params' : PropTypes.shape({  
      'buildingID' : PropTypes.string,
    }),
  }),    
  'buildingInformation' : PropTypes.shape({
    'data': PropTypes.shape({
      'buildingRefNo': PropTypes.string,
      'buildingName': PropTypes.string,
      'buildingCompanyName': PropTypes.string,
      'buildingTaxID': PropTypes.string,
      'buildingPOSID': PropTypes.string,
      'buildingAddress': PropTypes.string,
      'buildingContactName': PropTypes.string,
      'buildingContactNumber': PropTypes.string,
      'buildingEmergencyContactNumber': PropTypes.string,
      'buildingContactEmail': PropTypes.string,
      'buildingMerchantID': PropTypes.string,
      'buildingDashboardURL': PropTypes.string,
      'buildingVatRatePercentage': PropTypes.number,
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'buildingParkingFeeModelCar': PropTypes.shape({
    'data': PropTypes.shape({
      'isCanSave' : PropTypes.bool,
      'parkingFeeModelData' : PropTypes.string,
      'parkingFeeModel' : PropTypes.string,
    }),
  }),
  'buildingParkingFeeModelMotorcycle': PropTypes.shape({
    'data': PropTypes.shape({
      'isCanSave' : PropTypes.bool,
      'parkingFeeModelData' : PropTypes.string,
      'parkingFeeModel' : PropTypes.string,
    }),
  }),
  'redemptionModelInformation': PropTypes.shape({
    'data': PropTypes.shape({
      'maximumRedemptionMinutesCar' : PropTypes.number,
      'maximumRedemptionQuotaCar' : PropTypes.number,
      'maximumRedemptionMinutesMotorcycle' : PropTypes.number,
      'maximumRedemptionQuotaMotorcycle' : PropTypes.number,
      'redemptionModelCar' : PropTypes.string,
      'redemptionModelMotorcycle' : PropTypes.string,
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'configCommon': PropTypes.shape({
    'data': PropTypes.shape({
      'maximumParkingFeePerDayActive' : PropTypes.string,
      'maximumParkingFeePerDay' : PropTypes.number,
      'exitPeriodAfterPayment' : PropTypes.number,
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'config': PropTypes.shape({
    'data': PropTypes.shape({
      'buildingConfigCar' : PropTypes.shape({        
        'overNightActive' : PropTypes.string,
        'overnightTimeStart': PropTypes.string,
        'overnightTimeEnd': PropTypes.string,
      }),
      'buildingConfigMotorcycle' : PropTypes.shape({
        'overNightActive' : PropTypes.string,
        'overnightTimeStart': PropTypes.string,
        'overnightTimeEnd': PropTypes.string,
      }),
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'buildingContent': PropTypes.shape({
    'data': PropTypes.shape({
      'buildingContentTH' : PropTypes.shape({}),
      'buildingContentEN' : PropTypes.shape({}),
      'isCanSave' : PropTypes.bool,
    }),
  }),
  'updateBuilding' : PropTypes.shape({
    'status': PropTypes.number,
    'type': PropTypes.string, 
  }),
  'getBuildingByRefNo' : PropTypes.shape({
    'status': PropTypes.number,
    'type': PropTypes.string,   
    'data' : PropTypes.shape({
      'building' : PropTypes.shape({
        'buildingInfo' : PropTypes.shape({
          'buildingTaxID' : PropTypes.string,
          'buildingPosID' : PropTypes.string,
          'buildingDashboardURL' : PropTypes.string,
        }),
        'buildingRefNo' : PropTypes.string,
        'buildingName' : PropTypes.string,
      }),
      'buildingConfig' : PropTypes.shape({
        'buildingConfigID' : PropTypes.string,
        'buildingConfig' : PropTypes.shape({          
          'config' : PropTypes.shape({  
            'common' : PropTypes.shape({
              'maximumParkingFeePerDayActive' : PropTypes.bool,
            }),
            'car' : PropTypes.shape({  
              'parking' : PropTypes.shape({
                'buildingFreeParking' : PropTypes.shape({
                  'freeParkingCondition' : PropTypes.string,
                  'freeParkingMinutes' : PropTypes.number,
                }),
                'overnight' : PropTypes.shape({
                  'active': PropTypes.bool,
                  'fee' : PropTypes.number,
                  'overnightChargeType' : PropTypes.string,
                  'timeStart' : PropTypes.string,
                  'timeEnd' : PropTypes.string,
                }),
              }),
            }),
            'motorcycle' : PropTypes.shape({  
              'parking' : PropTypes.shape({
                'buildingFreeParking' : PropTypes.shape({
                  'freeParkingCondition' : PropTypes.string,
                  'freeParkingMinutes' : PropTypes.number,
                }),
                'overnight' : PropTypes.shape({
                  'active': PropTypes.bool,
                  'fee' : PropTypes.number,
                  'overnightChargeType' : PropTypes.string,
                  'timeStart' : PropTypes.string,
                  'timeEnd' : PropTypes.string,
                }),
              }),
            }),
          }),
          'content' : PropTypes.shape({
            'th' : PropTypes.shape({
              'car' : PropTypes.shape({
                'parkingNote' : PropTypes.string,
                'paymentNote' : PropTypes.string,
                'tenantMemberParkingNote' : PropTypes.string,
              }),
              'common' : PropTypes.shape({
                'buildingLogoImage' : PropTypes.string,
                'welcomeVoiceURL' : PropTypes.string,

              }),
              'motorcycle' : PropTypes.shape({
                'parkingNote' : PropTypes.string,
                'paymentNote' : PropTypes.string,
                'tenantMemberParkingNote' : PropTypes.string,
              }),
            }),
            'en' : PropTypes.shape({
              'car' : PropTypes.shape({
                'parkingNote' : PropTypes.string,
                'paymentNote' : PropTypes.string,
                'tenantMemberParkingNote' : PropTypes.string,
              }),
              'common' : PropTypes.shape({
                'buildingLogoImage' : PropTypes.string,
                'welcomeVoiceURL' : PropTypes.string,
    
              }),
              'motorcycle' : PropTypes.shape({
                'parkingNote' : PropTypes.string,
                'paymentNote' : PropTypes.string,
                'tenantMemberParkingNote' : PropTypes.string,
              }),
            }),
          }),
        }),
      }),
      'buildingParkingFeeModel' : PropTypes.array,
      'buildingRedemptionModels' : PropTypes.array,
    }),
  }),
};
